export class Platform {
  public static get isMobile(): boolean {
    const winWidth = window.innerWidth;

    return winWidth < 959;
  }
}